import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_correctly_pay_wrkrs_for_any_of_these_type'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_correctly_pay_wrkrs_for_any_of_these_type',
  name: 'Is the facility failing to correctly pay workers for any of these types of leave, as legally required: \r\r\n• All public holidays\r\r\n• Annual leave \r\r\n• Sick leave\r\r\n• Maternity leave\r\r\n• Paternity leave\r\r\n• Personal leave\r\r\n• Other types of required leave?',
  description:
    'Answer No if the facility is correctly paying all workers for all types of leave as legally required.\r\r\n\r\r\nConsult applicable legal requirements to determine entitlements, accrual of, and ability to take leave and relating payment for leave.\r\r\n\r\r\nIssues regarding time off for leave are covered separately.\r\r\n\r\r\nIf there are no applicable legal requirements, select No applicable legal requirements. \r\r\n\r\r\n',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-78',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9630,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
